import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GerenciarSaidaCaixaService } from 'src/app/admihair/service/gerenciar-saida-caixa.service';
import { AdmihairBaseComponent } from '../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { PageResponse } from 'src/app/admihair/api/dto/paginacao/page-response';
import { LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { FluxoSaidaCaixa } from 'src/app/admihair/api/dto/fluxo-saida-caixa';

@Component({
  selector: 'app-gerenciar-saida-caixa',
  templateUrl: './gerenciar-saida-caixa.component.html',
  styleUrls: ['./gerenciar-saida-caixa.component.scss']
})
export class GerenciarSaidaCaixaComponent extends AdmihairBaseComponent implements OnInit {

  loading: boolean = true;
  loadingProcessar: boolean = false;
  exibirDialogAcao: boolean = false;
  listaPlanoContas: PlanoContaEmpresa[] = [];
  planoContaSelecionado?: PlanoContaEmpresa;
  saidaSelecionada?: FluxoSaidaCaixa;

  ordenacao: string = "";
  numeroPagina: number = 0;
  tamanhoPagina: number = 10;

  itensPaginados: PageResponse<FluxoSaidaCaixa> = {
    content: [],
    number: 0,
    size: 0,
    totalElements: 0,
    totalPages: 0,
    last: false
  }

  constructor(
    private gerenciarSaidaCaixaService: GerenciarSaidaCaixaService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    erroService: ErroService,
    storageService: UtilStorageService,
  ) {
    super(erroService, storageService)
  }

  ngOnInit(): void {
    this.permissaoListar = this.verificarPermissao('PERM_DIRECIONAR_SAIDA_CAIXA');
  }

  onLazyLoad(event: LazyLoadEvent) {

    if (event.first !== undefined && event.rows !== undefined) {
      if (event.first === 0 && event.rows === 0) {
        this.numeroPagina = 0;
      } else {
        this.numeroPagina = event.first / event.rows;
      }
    }
    if (event.rows) {
      this.tamanhoPagina = event.rows;
    }
    this.definirOrdenacao(event.sortField, event.sortOrder);
    this.listar();
  }

  definirOrdenacao(sortField?: string, sortOrder?: number) {
    const campoDeOrdenacao = sortField ? sortField : "dataVencimento";
    const direcaoOrdenacao = sortOrder === -1 ? "DESC" : "ASC";
    this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
  }


  listar() {
    this.loading = true;
    this.gerenciarSaidaCaixaService.listar(
      this.numeroPagina,
      this.tamanhoPagina,
      this.ordenacao
    ).subscribe({
      next: (data: PageResponse<FluxoSaidaCaixa>) => {
        this.itensPaginados = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  abrirDialog(item: FluxoSaidaCaixa) {
    this.planoContaSelecionado = undefined;
    this.saidaSelecionada = item;
    this.exibirDialogAcao = true;
    this.buscarContas();
  }


  buscarContas() {
    const utilizacoes: string[] = ['DESPESA', 'FOLHA/DESPESA'];
    this.planoContaEmpresaService.listarPorEmpresaEUtilizacao(this.getEmpresa().id, utilizacoes)
      .subscribe({
        next: (data: PlanoContaEmpresa[]) => {
          this.listaPlanoContas = data;
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      })
  }

  processar() {
    this.loadingProcessar = true;
    this.gerenciarSaidaCaixaService.processar(
      {
        idFluxoFinanceiro: this.saidaSelecionada?.id,
        codigoPlanoConta: this.planoContaSelecionado?.codigo,
        empresaId: this.getEmpresa().id
      }
    ).subscribe({
      next: () => {
        this.loadingProcessar = false;
        this.exibirDialogAcao = false;
        this.listar();
        this.exibirMensagemSucesso();
      },
      error: (err: any) => {
        this.loadingProcessar = false;
        this.exibirDialogAcao = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  limpar(table: Table) {
    table.clear();
  }

}
